var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.theme,attrs:{"id":"app"}},[_c('Tealium'),_c('ConsentManager'),_c('AppForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }